/**
 * @generated SignedSource<<ebae146d94aa55fa707a8e206607bd1b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectCategoryPicker$data = {
  readonly allJiraProjectCategories: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ProjectCategoryPicker";
};
export type ProjectCategoryPicker$key = {
  readonly " $data"?: ProjectCategoryPicker$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectCategoryPicker">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "ProjectCategoryPicker",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "concreteType": "JiraProjectCategoryConnection",
      "kind": "LinkedField",
      "name": "allJiraProjectCategories",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraProjectCategoryEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraProjectCategory",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "id"
                },
                {
                  "kind": "ScalarField",
                  "name": "name"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraQuery"
};

(node as any).hash = "a6ae0938639facc31644461a652a173a";

export default node;
